import styled from '@emotion/styled';
import { Heading } from '../Heading';

export const SectionHeading = styled(Heading)`
    max-width: 650px;
`;
